<!-- 腾币商城主页 -->
<template>
    <div class="shop-home">
        <!-- <div class="home-bg" style="">
            <img loading="lazy" :src="require('@/assets/shop/bg.jpg')"/>
        </div> -->
        <!-- <div class="home-top" style="">
            <div class="top-icon"> 
                <div class="point"> 
                    <img loading="lazy" class="coin-icon" :src="require('@/assets/shop/coin.png')"/><div class="amout">{{ userRmb }}</div>
                </div>
                <img loading="lazy" class="reports" :src="require('@/assets/shop/reports.png')" @click="routing(1)"/>
                <img loading="lazy" style="margin-left: 20px;" :src="require('@/assets/shop/rule.png')" @click="routing(2)"/>
            </div>
        </div> -->
        <barrages :barragesList="barragesList"></barrages>
        <lottery @routing="routing"></lottery>
        <!-- 虚拟商品 -->
        <virtualProduct ref="virtualProduct" />
        <!-- 实用商品 -->
        <practicalGoods ref="practicalGoods" />
        <prizeList ref="prizeList" />
        <records ref="records" />
        <Mallrules ref="mallrules" />
         <Pop
          :visible="signDialog"
          :imageUrl="imageUrl"
          @close="signDialog = false"
          :width="signSucceed?'468px':'278px'"
          :height="signSucceed?'495px':'200px'"
        >
          <div v-if="signSucceed">
            <h2 class="contentH top42">{{$t('恭喜获得')}}</h2>
             <p class="contentP">
               <span class="contentP_1">{{signPoint}}</span>
               <span>{{$t('积分 ')}} </span>
             </p>
             <div  class="contentH top60">
                <p>{{$t('积分已自动到账')}} </p>
                <p>{{$t('请及时查看积分余额')}}</p>
             </div>
          </div>
          <div v-else>
            <div v-if="haveSignedIn">
                <div class="contentH top60">
                    <p>{{$t('您今日已签到过')}}</p>
                     <p>{{$t('请明日再来')}}</p>
                </div>
            </div>
             <div v-else>
                <div class="contentH top60">
                    <p>{{$t('您的签到任务还未完成')}}</p>
                    <p>{{$t('请先完成签到任务再进行签到')}}</p>
                </div>
            </div>
          </div>
        </Pop>
    </div>
</template>
<script>

import Pop from "@/components/pop";
import barrages from "./components/barrages.vue";
import virtualProduct from "./components/virtualProduct";
import practicalGoods from "./components/practicalGoods";
import prizeList from "./components/prizeList";
import records from "./components/records.vue";
import Lottery from "./components/Lottery";
import Mallrules from "./mallrules";
import { mapState, mapMutations } from "vuex";
export default {
    components: {
        Pop,
        barrages,
        virtualProduct,
        practicalGoods,
        prizeList,
        records,
        Mallrules,
        Lottery
    },
    data () {
        return {
            signPoint:null,
            signSucceed:false,
            imageUrl:'',
            signDialog:false,
            problemList: [],
            index: 0,
            shoppingMallList: {}, //商品列表数据
            barragesList: [], //弹幕数据
        }
    },
    computed: mapState({
        clientMalls: (state) => state.clientMall,
        showDialg: (state) => state.showDialg,
        userRmb: (state) => state.userRmb,
    }),
    created () {
        this.getData();
        this.getMemberPoint();
        this.getshoppingMallList();
    },
    methods: {
        ...mapMutations(["setClientMall", "setUserRmb"]),
        routing(type) {
            switch (type) {
                case 0:
                    //奖品列表
                    this.$refs.prizeList.openDialog();
                    break;
                case 1:
                    // 记录;
                    this.$refs.records.openDialog();
                    break;
                case 2:
                    //规则（新窗口跳转）
                    this.$refs.mallrules.openDialog();
                    // this.$router.push("/mallrules");
                    break;
                case 3:
                    //签到
                    this.onSign()
                    
                    // this.$router.push("/mallrules");
                    break;
                default:
                    break;
            }
        },
        onSign() {
            this.$http.get(this.$api.doSignIn).then((res) => {
                if (res.data) {
                    this.haveSignedIn = res.data.haveSignedIn
                    this.signPoint = res.data.signPoint||''
                    this.signSucceed = res.data.signSucceed
                    if (res.data.signSucceed) {
                     this.imageUrl = require('@/assets/shop/PC/Frame29.png')
                    } else {
                        if (this.haveSignedIn) {
                        this.imageUrl = require('@/assets/shop/PC/FrameC.png')
                        }else{
                        this.imageUrl = require('@/assets/shop/PC/FrameF.png')
                        }
                    }
                    this.getMemberPoint()
                    this.signDialog = true
                }
            });
        },
        getData() {
            this.$http.get(this.$api.getClientMall).then((res) => {
                if (res.code == 0) {
                    this.setClientMall(res.data);
                }
            });
        },
        getMemberPoint() {
            if (!this.$common.getUser()) return
            this.$http.get(this.$api.getMemberPoint).then((res) => {
                if (res.code == 0) {
                    this.setUserRmb(res.data.balance);
                }
            });
        },
        //获取商品列表
        getshoppingMallList() {
            this.$http.get(this.$api.shoppingMallList).then((res) => {
                // console.log('res;', res)
                if (res.code == 0) {
                    this.shoppingMallList = res.data;
                    this.$refs.virtualProduct.virtualMallVOList =
                        res.data.virtualMallVOList; //虚拟商品数据
                    this.$refs.practicalGoods.shoppingMallVOList =
                        res.data.shoppingMallVOList; //实用商品数据
                    this.barragesList = res.data.luckyMallVOList;
                    // console.log('barrages.vue:', this.barragesList)
                    this.$refs.virtualProduct.limitCount = res.data.limitCount;
                    this.$refs.practicalGoods.limitCount = res.data.limitCount;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.shop-home {
    background: #06001a url("../../assets/shop/bg.jpg") no-repeat center top; 
    background-size: 1920px 2806px;
    min-width: 1200px;
    overflow: hidden;
    position: relative;
}
.home-top {
    margin: 0 auto;
    margin-top: 12px;
    width: 1200px;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    .top-icon {
        display: flex;
        flex-flow: row;
        height: 30px;
        width: 286px;
        img{
            height: 30px;
            transform: scale(1.4);
            margin-top: 3px;
            cursor: pointer;
        }
        .amout {
            padding-top: 5px;
            padding-left: 5px;
            color: #fff;
        }
        .reports {
            margin: 0 16px 0 30px;
            margin-top: 3px;
        }
        .point {
            border: 1px solid #fff;
            border-radius: 20px;
            width: 94px;
            height: 30px;
            display: flex;
            z-index: 1;
            .coin-icon {
                margin-left: 10px;
                margin-top: 5px;
                height: 20px;
            }
            img{
                height: 30px;
            }
        }
    }
}
::v-deep .home-bg {
    min-width: 1200px;
    position: absolute;
    top: 0;
    width:100%;
    z-index:-1;
    img {
        width: 100%;
    }
}
</style>